import axios from './axiosInstance';

export const createImportAttempt = async (file) => {
  const headers = { 'Content-Type': 'multipart/form-data' }

  const formData = new FormData();
  formData.append('import_attempt[file]', file);

  const response = await axios.post("/club_api/import_attempts/", formData, { headers })
  return response.data;
};

export const processImportAttempt = async (id, mapping) => {
  const response = await axios.put(`/club_api/import_attempts/${id}`, {mapping});
  return response.data;
};

export const showImportAttempt = async id => {
  const response = await axios.get(`/club_api/import_attempts/${id}`);
  return response.data;
};
